import React, { useContext } from 'react';
import { css } from 'emotion';
import theme from '@vromo/ui/components/theme';
import styled from '@emotion/styled';
import { qaLabelCampaigns } from './../../../common-qa-labels/campaigns';
import { buildDynamicLabel } from './../../../common-qa-labels/utils';

const Container = styled.div<{ selected: boolean }>`
    display: flex;
    align-items: center;
    text-align: center;
    cursor: pointer;
    font-weight: bold;
    font-size: 14px;

    padding: 4px 20px;
    margin: 10px;
    white-space: nowrap;

    transition: border 300ms ease-in-out;
    border-bottom: 4px solid ${({ selected }) => (selected ? theme.primary : theme.grey)};

    :hover {
        border-bottom: 4px solid ${theme.primary};
    }
`;

const TabsContext = React.createContext({
    currentTab: '',
    onChange: () => {}
});

type TabsProps = {
    children: any;
    currentTab: string;
    onChange: (tab: string) => void;
};
export const Tabs = function Tabs({ children, currentTab, onChange }: TabsProps) {
    return (
        <TabsContext.Provider value={{ currentTab, onChange }}>
            <div
                className={css`
                    display: flex;
                    overflow: auto;
                    flex-shrink: 0;
                `} 
                data-testid={qaLabelCampaigns.editModal.tabsList}>
                {children}
            </div>
        </TabsContext.Provider>
    );
};

type TabProps = {
    id: string;
    children: any;
};
export const Tab = function Tab({ id, children }: TabProps) {
    const { currentTab, onChange } = useContext(TabsContext);

    return (
        <Container selected={currentTab === id} onClick={() => onChange(id)} data-testid={buildDynamicLabel(qaLabelCampaigns.editModal.tabItem, id?.toString())}>
            {children}
        </Container>
    );
};
